module.exports = __webpack_public_path__ + "assets/rechargelady.689d3adf.svg";